module.exports = __webpack_public_path__ + "static/media/ic_search.c70a5292.svg";